import { render, staticRenderFns } from "./UsuariosCadastro.vue?vue&type=template&id=4a9ddfaa&scoped=true&"
import script from "./UsuariosCadastro.vue?vue&type=script&lang=js&"
export * from "./UsuariosCadastro.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosCadastro.vue?vue&type=style&index=0&id=4a9ddfaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ddfaa",
  null
  
)

export default component.exports